"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtSearch = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtSearch = function SvgBtSearch(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.8599 21.184L17.9716 17.2958C19.0147 16.0967 19.6461 14.5322 19.6461 12.8222C19.6461 9.05809 16.5845 6 12.824 6C9.05989 6 6.0018 9.06164 6.0018 12.8222C6.0018 16.5827 9.06344 19.6443 12.824 19.6443C14.534 19.6443 16.0985 19.0129 17.2976 17.9698L21.1858 21.8581C21.2781 21.9503 21.4022 22 21.5229 22C21.6435 22 21.7677 21.9539 21.8599 21.8581C22.0444 21.6736 22.0444 21.3685 21.8599 21.184ZM6.95612 12.8222C6.95612 9.5867 9.5885 6.95787 12.8204 6.95787C16.0559 6.95787 18.6847 9.59024 18.6847 12.8222C18.6847 16.0541 16.0559 18.69 12.8204 18.69C9.5885 18.69 6.95612 16.0576 6.95612 12.8222Z",
    fill: "currentColor"
  }));
};

exports.SvgBtSearch = SvgBtSearch;